'use client';

import React from 'react';

import { clsx } from 'clsx';

import styles from './styles.module.css';

import { Breadcrumbs } from '@/components/Breadcrumbs';
import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';
import { useBreadcrumbTrackingOnClick } from '@/modules/browse/hooks';
import { useProductBreadcrumbs } from '@/modules/product/hooks/useProductBreadcrumbs';
import { useProductsSearchBar } from '@/modules/product/hooks/useProductsSearchBar';

export function ProductBreadcrumbs() {
  const { isLoading, breadcrumbs } = useProductBreadcrumbs();
  const onBreadcrumbClick = useBreadcrumbTrackingOnClick();
  const { isVisible } = useProductsSearchBar();

  const breadcrumbsClassname = isVisible
    ? styles.productBreadcrumbsWithSearchbar
    : styles.productBreadcrumbs;

  if (isLoading) {
    return (
      <div className={styles.container}>
        <Placeholder
          className={clsx(breadcrumbsClassname, styles.skeleton)}
          shape={PlaceHolderShape.RECTANGLE}
          width="100%"
          height="18px"
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Breadcrumbs
        onBreadcrumbClick={onBreadcrumbClick}
        className={breadcrumbsClassname}
        items={breadcrumbs}
      />
    </div>
  );
}
